export const formatRows = (data) =>
  data.map((event) => ({
    id: event.id,
    name: event.name,
    page_name: event.page_name,
    date: event.date,
    location: event.location,
    matched_count: event.matched_count,
    unmatched_count: event.unmatched_count,
    rawEvent: event, // for use in renderCell if needed
  }));
